'use strict';

export const DOMAIN_FIELD_TYPES = {
  boolean: {enumerable: true, name: 'boolean'},
  number: {enumerable: true, name: 'number'},
  string: {enumerable: true, name: 'string'},
  email: {enumerable: true, name: 'email'},
  URL: {enumerable: true, name: 'URL'},
  creditCard: {enumerable: true, name: 'creditCard'},
  Date: {enumerable: true, name: 'Date'},
  JSON: {enumerable: true, name: 'JSON'},
  GeoJSON: {enumerable: true, name: 'GeoJSON'},
  Domain: {enumerable: true, name: 'Domain'},
  DomainLink: {enumerable: true, name: 'DomainLink'},
  NestedDocument: {enumerable: true, name: 'NestedDocument'},
  DomainCollection: {enumerable: false, name: 'DomainCollection'},
  LinkedDocument: {enumerable: false, name: 'LinkedDocument'}
};



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/domain-properties/DOMAIN_FIELD_TYPES.js